import { zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

export const createLocalSchema = z.object({
    nomeLocal: z.string().min(1, 'Obrigatório'),
    latitude: z.number().or(z.string()).transform(String),
    longitude: z.number().or(z.string()).transform(String),
    endereco: z.string().min(1, 'Obrigatório'),
    cercaEletronica: z
        .string()
        .refine(
            value => !isNaN(Number(value)) && Number(value) > 0,
            'Deve ser um número',
        ),
})

export const updateLocalSchema = createLocalSchema.extend({
    id: z.number(),
    empresaId: z.number(),
    FuncionarioLocais: z.array(zod.FuncionarioLocaisSchema).nullish(),
})

export type Local = z.infer<typeof updateLocalSchema>

const funcionarioLocaisSchema = zod.FuncionarioLocaisSchema.omit({
    __typename: true,
    createdAt: true,
})

export type FuncionarioLocais = z.infer<typeof funcionarioLocaisSchema>

interface Coordenadas {
    latitude: number
    longitude: number
}
export type Endereco = Coordenadas & {
    endereco: string
}

const service = new ApiService<Local>('locais')
const funcionarios = new ApiService<FuncionarioLocais>('locais-funcionarios')
const endereco = new ApiService<Endereco, Endereco, Coordenadas>(
    'locais/endereco',
)
const coordenadas = new ApiService<
    Coordenadas,
    Coordenadas,
    {
        endereco: string
    }
>('locais/coordenadas')

const all = new ApiService<Local>('locais/all')

export const local = Object.assign(service, {
    funcionarios,
    endereco,
    coordenadas,
    all,
})
